import { useMutation, useQuery, useQueryClient } from 'react-query';
import { FeatureFlag, useFeatureToggle } from 'modules/unleash';
import { useAccessToken } from 'utils/auth';
import {
  getNotificationPreferences,
  updateNotificationPreferences
} from './api';
import { NotificationPreferences } from './types';

export const usePreferencesMutation = () => {
  const { token } = useAccessToken();
  const queryClient = useQueryClient();

  return useMutation(
    ['update-preferences', token],
    ({
      pushPermission,
      refId,
      ...preferences
    }: NotificationPreferences & { pushPermission: boolean; refId: string }) =>
      updateNotificationPreferences(token, preferences, pushPermission, refId),
    {
      onSuccess: () => {
        void queryClient.invalidateQueries(['get-preferences']);
      }
    }
  );
};

export const usePreferencesQuery = () => {
  const { token } = useAccessToken();

  const { isEnabled: isPushEnabled } = useFeatureToggle(
    FeatureFlag.PRO_TALENT_IS_PUSH_ENABLED
  );

  return useQuery(
    ['get-preferences', token],
    () => getNotificationPreferences(token),
    {
      enabled: !!token && isPushEnabled
    }
  );
};
